/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteGeneticsReportsRequestDto
 */
export interface DeleteGeneticsReportsRequestDto {
    /**
     * Array of genetics report IDs to delete
     * @type {Array<string>}
     * @memberof DeleteGeneticsReportsRequestDto
     */
    ids: Array<string>;
}

/**
 * Check if a given object implements the DeleteGeneticsReportsRequestDto interface.
 */
export function instanceOfDeleteGeneticsReportsRequestDto(value: object): value is DeleteGeneticsReportsRequestDto {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    return true;
}

export function DeleteGeneticsReportsRequestDtoFromJSON(json: any): DeleteGeneticsReportsRequestDto {
    return DeleteGeneticsReportsRequestDtoFromJSONTyped(json, false);
}

export function DeleteGeneticsReportsRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteGeneticsReportsRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
    };
}

export function DeleteGeneticsReportsRequestDtoToJSON(json: any): DeleteGeneticsReportsRequestDto {
    return DeleteGeneticsReportsRequestDtoToJSONTyped(json, false);
}

export function DeleteGeneticsReportsRequestDtoToJSONTyped(value?: DeleteGeneticsReportsRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
    };
}

